import { MultiValue, useMultiSelect } from '@any-ui-react/select';

import { OptionList, Option } from '../../../types/basic';

import { ValueEditorInputProps } from './useValueEditor';

interface UseMultiSelectEditorReturnProps {
  options?: OptionList;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getMultiSelectEditorValue: (i?: number) => any | undefined;
  handleMultiSelectEditorValueChange: (option?: MultiValue<Option>) => void;
  isMulti: true;
  closeMenuOnSelect: boolean;
}

export const useMultiSelectEditor = ({
  field,
  values,
  handleSingleValue,
}: ValueEditorInputProps): UseMultiSelectEditorReturnProps => {
  const options = field.values;
  const multiValueSelect = useMultiSelect({ options: options ?? [] });
  return {
    ...multiValueSelect,
    options,
    getMultiSelectEditorValue: () =>
      options?.filter((option) => {
        return 'value' in option && values?.includes(option.value);
      }),
    handleMultiSelectEditorValueChange: (options) => {
      handleSingleValue(options?.map((option) => option.value));
    },
  };
};
